import { render, staticRenderFns } from "./SelectSchoolModal.vue?vue&type=template&id=c75e8a86&"
import script from "./SelectSchoolModal.vue?vue&type=script&lang=js&"
export * from "./SelectSchoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports